import type { DataMessagePartComponent } from "@assistant-ui/react";
import { FileTextIcon } from "lucide-react";
import { type PageContextData, type QuoteData, tabLabel } from "@/lib/page-context";

function host(url: string | undefined): string {
  try {
    return new URL(url ?? "").host;
  } catch {
    return "";
  }
}

/** A page shared from the side panel, shown on the question it was asked with. */
export const SharedPagePart: DataMessagePartComponent<PageContextData> = ({ data }) => {
  const label = tabLabel(data);
  return (
    <a
      href={data.url}
      target="_blank"
      rel="noreferrer"
      title={data.url}
      data-slot="aui_shared-page"
      className="border-border bg-background/60 hover:bg-background mb-2 flex max-w-full items-center gap-2 border px-2 py-1 text-xs no-underline transition-colors"
    >
      <FileTextIcon className="text-muted-foreground size-3.5 shrink-0" />
      <span className="min-w-0 truncate font-medium">{label}</span>
      {host(data.url) && label !== host(data.url) && (
        <span className="text-muted-foreground shrink-0">{host(data.url)}</span>
      )}
    </a>
  );
};

/** Text quoted from a page, shown above the question. */
export const QuotePart: DataMessagePartComponent<QuoteData> = ({ data }) => (
  <blockquote
    data-slot="aui_quote"
    className="border-foreground/30 text-muted-foreground mb-2 line-clamp-4 border-l-2 pl-2.5 text-sm whitespace-pre-wrap"
    title={data.title ?? data.url}
  >
    {data.text}
  </blockquote>
);
